<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low-and-right"
            width="table-action-menu--only-one">
            <delete-button
                :url="route('tenantapi.clients.user-groups.courses.destroy', {'client': client.id, 'user_group': userGroup.id, 'course': data.id})"
                :confirmTitle="this.trans('user_groups.note.unassign_course_title')"
                :confirmText="this.trans('user_groups.note.unassign_course_message')"
                :errorFlashMessage="this.trans('user_groups.flash.not_unassigned')"
                :deleteId="data.id"
                grid="table-action-cell--grid-1of1"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'client', 'userGroup'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
